import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, SelectInput, EMPTY_ARRAY, NumberInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { onChangeOfferValueAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	bucketName: yup.string().required('Bucket Name is a required field'),
	limitBasedOffer: yup.boolean(),
	segmentType: yup.string().required('Please select segment type'),
	isActive: yup.boolean(),
	segmentExclusive: yup.string(),
	transactionRange: yup
		.array()
		.of(
			yup.object().shape({
				start: yup.string().required('start range is required field'),
				end: yup.string(),
				offerPercentage: yup.number().required('Offer percentage is required'),
				cashbackPercentage: yup.number().required('Cashback percentage is required'),
				bonusPercentage: yup.number().required('Bonus percentage is required')
			})
		)
		.required()
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	bucketName: yup.string().required('Bucket Name is a required field'),
	limitBasedOffer: yup.boolean(),
	isActive: yup.boolean(),
	segmentExclusive: yup.string(),
	transactionRange: yup
		.array()
		.of(
			yup.object().shape({
				start: yup.string().required('start range is required field'),
				end: yup.string(),
				offerPercentage: yup.number().required('Offer percentage is required'),
				cashbackPercentage: yup.number().required('Cashback percentage is required'),
				bonusPercentage: yup.number().required('Bonus percentage is required')
			})
		)
		.required()
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	BUCKET_NAME: 'bucketName',
	IS_ACTIVE: 'isActive',
	LIMIT_BASED_OFFER: 'limitBasedOffer',
	SEGMENT_EXCLUSIVE: 'segmentExclusive',
	SEGMENT_TYPE: 'segmentType',
	START_RANGE: 'start',
	END_RANGE: 'end',
	OFFER_PERCENTAGE: 'offerPercentage',
	CASHBACK_PERCENTAGE: 'cashbackPercentage',
	BONUS_PERCENTAGE: 'bonusPercentage',
	TRANSACTION_RANGE: 'transactionRange',
	FORM: 'form'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_TYPE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.SEGMENT_EXCLUSIVE)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.LIMIT_BASED_OFFER)])
	]),
	new Row(FORM_FIELD_KEYS.TRANSACTION_RANGE, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.START_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.END_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.OFFER_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_PERCENTAGE)])
	])
];

export const EDIT_GST_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.SEGMENT_EXCLUSIVE)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.LIMIT_BASED_OFFER)])
	]),
	new Row(FORM_FIELD_KEYS.TRANSACTION_RANGE, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.START_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.END_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.OFFER_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_PERCENTAGE)])
	])
];

const sampleData: { [key: string]: string } = { id: '1', label: 'TEST' };
const userSegementType: { [key: string]: string } = { id: 'user', label: 'USER' };
const liveSegementType: { [key: string]: string } = { id: 'live', label: 'LIVE' };

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [sampleData],
			required: true
		})
		.setToolTip('GST Segment Name'),
	[FORM_FIELD_KEYS.BUCKET_NAME]: new RenderConfig()
		.setName('bucketName')
		.setId('bucketName')
		.setLabel('Bucket Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true
		})
		.setToolTip('GST Bucket Name'),
	[FORM_FIELD_KEYS.LIMIT_BASED_OFFER]: new RenderConfig()
		.setName('limitBasedOffer')
		.setLabel('Is Limit Based Offer')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('Is limit based offer or not'),
	[FORM_FIELD_KEYS.IS_ACTIVE]: new RenderConfig()
		.setName('isActive')
		.setLabel('Is Offer Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('Is offer active or not'),
	[FORM_FIELD_KEYS.SEGMENT_EXCLUSIVE]: new RenderConfig()
		.setName('segmentExclusive')
		.setLabel('Segment Exclusive')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		})
		.setToolTip('Is offer limit based or not'),
	[FORM_FIELD_KEYS.SEGMENT_TYPE]: new RenderConfig()
		.setName('segmentType')
		.setLabel('Move Segment To.')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [liveSegementType, userSegementType],
			required: true
		})
		.setToolTip('GST segment type'),
	[FORM_FIELD_KEYS.TRANSACTION_RANGE]: new RenderConfig()
		.setName('transactionRange')
		.setLabel('Transaction Range Details')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.START_RANGE]: new RenderConfig()
		.setName('start')
		.setLabel('GST offer start range(₹)(Incl.)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.END_RANGE]: new RenderConfig()
		.setName('end')
		.setLabel('GST offer end range(₹)(Excl.)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.OFFER_PERCENTAGE]: new RenderConfig()
		.setName('offerPercentage')
		.setLabel('GST Offer Percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.CASHBACK_PERCENTAGE]: new RenderConfig()
		.setName('cashbackPercentage')
		.setLabel('GST Cashback Percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.BONUS_PERCENTAGE]: new RenderConfig()
		.setName('bonusPercentage')
		.setLabel('GST Bonus Percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		})
};

export const GST_OFFER_UPDATE_CONFIG = {
	...FORM_FIELD_CONFIG,
	[FORM_FIELD_KEYS.FORM]: new RenderConfig()
		.setName('form')
		.setLabel('Offer form')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true
		})
};

export const getFormDefaults = (segmentList: any) => {
	return {
		segmentName: segmentList,
		bucketName: 'control',
		isActive: true,
		segmentExclusive: '',
		limitBasedOffer: false,
		transactionRange: [
			{
				start: '0',
				offerPercentage: 0,
				cashbackPercentage: 0,
				bonusPercentage: 0
			}
		]
	};
};
